import React from 'react'

/**
 * Centred full-page OTP layout (no sidebar). Modal uses its own padding wrapper instead.
 */
export default function PageOtpShell({ backLink, children }) {
  return (
    <div className="dqr-page-account-shell">
      {backLink ? <div className="shrink-0">{backLink}</div> : null}
      <div className="dqr-page-account-body">
        {children}
      </div>
    </div>
  )
}
